import React from 'react';

export type EstadoSeguimiento = 'pendiente' | 'cumplida' | 'no_cumplida';

export const OPCIONES_SEGUIMIENTO: Array<{ value: EstadoSeguimiento; label: string }> = [
  { value: 'pendiente', label: 'Pendiente' },
  { value: 'cumplida', label: 'Cumplida' },
  { value: 'no_cumplida', label: 'No cumplida' },
];

const ESTILOS: Record<EstadoSeguimiento, string> = {
  pendiente: 'bg-gray-100 text-gray-600',
  cumplida: 'bg-green-100 text-green-700',
  no_cumplida: 'bg-red-100 text-red-700',
};

export const normalizarEstado = (estado?: string | null): EstadoSeguimiento =>
  estado === 'cumplida' || estado === 'no_cumplida' ? estado : 'pendiente';

export const EstadoSeguimientoBadge: React.FC<{ estado?: string | null }> = ({ estado }) => {
  const value = normalizarEstado(estado);
  const label = OPCIONES_SEGUIMIENTO.find((o) => o.value === value)?.label ?? 'Pendiente';
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium ${ESTILOS[value]}`}
    >
      {label}
    </span>
  );
};
